import React from 'react'

import { Worker } from '~/components'
import { fetchETHYieldData, getPurchasesRef, getYieldETHRefTest } from '~/firebase'
import { PurchasedProduct, YieldValue } from '~/types'

import './style.css'


export default class Dashboard extends React.Component {
  state = {
    expiredPurchases: [] as PurchasedProduct[],
    fiatValue: {}, // remove after UX is delivered
    purchases: [] as PurchasedProduct[],
    yieldData: {}, // remove after UX is delivered
    yieldValues: [] as YieldValue[],
  }

  purchasesRef = getPurchasesRef()
  yieldRef = getYieldETHRefTest()

  componentDidMount() {
    this.yieldRef.on('value', this.setYield)
    this.purchasesRef.on('value', this.setPurchases)
    fetchETHYieldData().then(data => this.setState(data))
  }

  componentWillUnmount() {
    this.yieldRef.off()
    this.purchasesRef.off()
  }

  setYield = (snapshot: firebase.database.DataSnapshot) => {
    const yieldValues: YieldValue[] = []

    snapshot.forEach(item => (yieldValues.push({...item.val(), timestamp: Number(item.key)}), false)) // return false is required by firebase docs

    this.setState({yieldValues})
  }

  setPurchases = (snapshot: firebase.database.DataSnapshot) => {
    const purchases: PurchasedProduct[] = []
    const expiredPurchases: PurchasedProduct[] = []

    snapshot.forEach(item => {
      const v: PurchasedProduct = item.val()

      v['_key'] = item.key

      const datePurchased = new Date(v.purchaseTimestamp)
      v.expirationTimestamp = new Date(
        datePurchased.getFullYear(),
        datePurchased.getMonth() + v.duration,
        datePurchased.getDate() - 1
      ).valueOf()

      if (v.expirationTimestamp > new Date().valueOf()) purchases.push(v)
      else expiredPurchases.push(v)

      return false
    })

    this.setState({purchases, expiredPurchases})
  }

  renderPurchases = ({list, expired = false}) => list.length ? (
    <section style={{width: '100%'}}>
      { expired && <h2 className="kviPuT">Expired Workers</h2> }
      {
        list.map(item => (
          <article key={item._key} className={`ant-row larger ${expired ? 'expired' : ''}`}>
            <Worker item={item} yieldValues={this.state.yieldValues}/>
          </article>
        ))
      }
    </section>
  ) : null

  render() {
    const {purchases, expiredPurchases} = this.state

    return ( /* eslint-disable max-len */
      <div className="isoLayoutContentWrapper sc-kgoBCf gdNOpB">
        <h1 className="isoComponentTitle sc-jzJRlG kviPuT">My Workers</h1>

        <this.renderPurchases list={purchases}/>
        <this.renderPurchases list={expiredPurchases} expired/>

        <section className="ant-row larger">

          <div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24" style={{paddingLeft: 8, paddingRight: 8, marginBottom: 16}}>
            <div className="isoBoxWrapper sc-chPdSV cOTLJI">
              <div>
                <h3 className="isoBoxTitle sc-cSHVUG ifvfLf"> Dasboard overview </h3>
                <p className="isoBoxSubTitle sc-kAzzGY gCwUWQ"> Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet in aut tempore? Culpa quibusdam accusamus vero, veritatis odit deleniti repellendus, suscipit tempora sequi sapiente ex nesciunt dolores similique officiis quas! </p>
              </div>
            </div>
          </div>

          <div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24" style={{paddingLeft: 8, paddingRight: 8, marginBottom: 16}}>
            <div className="isoBoxWrapper sc-chPdSV cOTLJI">
              <div>
                <h3 className="isoBoxTitle sc-cSHVUG ifvfLf"> Raw data</h3>

                Purchase
                <pre>
                  {JSON.stringify(purchases[0], null, ' ')}<br/>
                </pre>

                Graph data (single point)
                <pre>
                  {JSON.stringify(this.state.yieldValues[0], null, ' ')}<br/>
                </pre>

                API data
                <pre>
                  {JSON.stringify(this.state, (k, v) => ['purchases', 'expiredPurchases', 'yieldValues'].some(t => t === k) ? undefined : v, ' ')}
                </pre>

              </div>
            </div>
          </div>

        </section>

      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.tsx